"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.retry = retry;
var _regeneratorRuntime2 = _interopRequireDefault(require("@babel/runtime/helpers/regeneratorRuntime"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
require("core-js/modules/es6.object.to-string.js");
require("core-js/modules/es6.promise.js");
/* eslint-disable no-await-in-loop, no-constant-condition */
function wait(ms) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, ms);
  });
}
function retry(_x) {
  return _retry.apply(this, arguments);
}
function _retry() {
  _retry = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(func) {
    var _ref,
      _ref$maxAttempts,
      maxAttempts,
      _ref$maxDelayMs,
      maxDelayMs,
      delay,
      attempts,
      _args = arguments;
    return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _ref = _args.length > 1 && _args[1] !== undefined ? _args[1] : {}, _ref$maxAttempts = _ref.maxAttempts, maxAttempts = _ref$maxAttempts === void 0 ? 10 : _ref$maxAttempts, _ref$maxDelayMs = _ref.maxDelayMs, maxDelayMs = _ref$maxDelayMs === void 0 ? 60 * 1000 : _ref$maxDelayMs;
            delay = 1000;
            attempts = 0;
          case 3:
            if (!true) {
              _context.next = 20;
              break;
            }
            _context.prev = 4;
            _context.next = 7;
            return func();
          case 7:
            return _context.abrupt("return", _context.sent);
          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](4);
            attempts += 1;
            if (!(attempts >= maxAttempts)) {
              _context.next = 15;
              break;
            }
            throw _context.t0;
          case 15:
            delay = Math.min(delay * Math.pow(2, attempts - 1), maxDelayMs);
            _context.next = 18;
            return wait(delay);
          case 18:
            _context.next = 3;
            break;
          case 20:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[4, 10]]);
  }));
  return _retry.apply(this, arguments);
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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